import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../_metronic/layout";
import { SchoolContextProvider } from "./components/SchoolDataContext";
import { SchoolEdit } from "./SchoolEdit";
import { SchoolList } from "./SchoolList";

export default function SchoolInformationPage({ history }) {
  const schoolUIEvents = {
    newSchoolButtonClick: () => {
      history.push("/school-information/add-school");
    },
    openEditSchoolPage: (id) => {
      history.push(`/school-information/${id}/edit-school`);
    },
    openActivateSchoolDialog: (id, isActive) => {
      // Updated route naming for consistency
      history.push(
        `/school-information/school-list/${id}/activate-school/${isActive}`
      );
    },
    openDeleteSchoolDialog: (id) => {
      // Updated route naming for consistency
      history.push(`/school-information/school-list/${id}/delete-school`);
    },
    openViewSchoolDialog: (id) => {
      // Optional: Add view dialog
      history.push(`/school-information/school-list/${id}/view-school`);
    },
  };

  return (
    <>
      <SchoolContextProvider schoolUIEvents={schoolUIEvents}>
        <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>
            <Redirect
              exact={true}
              from="/school-information"
              to="/school-information/school-list"
            />

            <ContentRoute
              path="/school-information/add-school"
              component={SchoolEdit}
            />

            <ContentRoute
              path="/school-information/:id/edit-school"
              component={SchoolEdit}
            />

            <ContentRoute
              path="/school-information/school-list"
              component={SchoolList}
            />

            {/* Optional: Add routes for dialogs if needed */}
            <ContentRoute
              path="/school-information/school-list/:id/activate-school/:isActive"
              component={SchoolList}
            />

            <ContentRoute
              path="/school-information/school-list/:id/delete-school"
              component={SchoolList}
            />

            <ContentRoute
              path="/school-information/school-list/:id/view-school"
              component={SchoolList}
            />
          </Switch>
        </Suspense>
      </SchoolContextProvider>
    </>
  );
}
